import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import { appReducer, AppState } from "store/app/reducer"
import { feedReducer, FeedState } from "store/feed/reducer"
import { sidebarReducer, SideBarState } from 'store/sidebar/reducer';
import { History } from 'history'

// The top-level state object
export interface ApplicationState {
    app: AppState;
    feed: FeedState;
    feedPrivate: FeedState;
    feedAnswers: FeedState;
    sidebar: SideBarState;
}

export enum FeedInstances {
    Main = "mainFeed",
    Private = "privateFeed",
    Answers = "answersFeed",
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const createRootReducer = (history: History) => combineReducers({
    router: connectRouter(history),
    app: appReducer,
    feed: createNamedWrapperReducer(feedReducer, FeedInstances.Main),
    feedPrivate: createNamedWrapperReducer(feedReducer, FeedInstances.Private),
    feedAnswers: createNamedWrapperReducer(feedReducer, FeedInstances.Answers),
    sidebar: sidebarReducer,
})


function createNamedWrapperReducer(reducerFunction: Function, reducerName: string) {
    return (state: any, action: any) => {
        const { instanceName } = action;
        const isInitializationCall = state === undefined;

        if (instanceName !== reducerName && !isInitializationCall && action.type.indexOf("@@Genie") == -1)
            return state;

        return reducerFunction(state, action)
    }
}
